import React, { Component } from 'react';
import loading from 'c-loading';
import native from 'c-up-native';
import lang from '../../../lang/index';
import Validate from '../../../global/validate';
import cache from '../../../global/cache';
import ProfileService from '../../../process/profile.service';
import Mlink from '../../../components/mlink';

export default class PayStackConfirmModal extends Component {
    constructor(props){
        super(props);

        this.cacheKey = 'paystack-info';
        this.userInfoCacheKey = 'userInfo';
        this.state = {};
    }

    componentWillMount() {
        const store = cache.getCache(this.cacheKey);
        let isInUpliveApp = native.getPlatform() === 'uplive';

        if (!store) {
            if (isInUpliveApp) {
                this.fetchAndUseUserInfo();
            }
        } else {
            this.setState({
                email: store.email
            });
        }
    }

    fetchAndUseUserInfo() {
        loading.show();
        const localUser = cache.getCache(this.userInfoCacheKey);

        native.getConfigs({
            invalid: 1,
            complete: confs => {
                const { uid, usertoken } = confs;
                ProfileService.fetchProfile(uid, usertoken).then( profileInfo => {
                    loading.hide();

                    if (profileInfo && profileInfo.mobilePhone) {
                        this.setState({
                            mobile: profileInfo.mobilePhone
                        });
                    }
                }, (err) => {
                    loading.hide();
                });
            }});
    }

    onInputChange(evt, key) {
        let value = evt.currentTarget.value;
        if (evt.currentTarget.type === 'checkbox') {
            value = evt.currentTarget.checked;
        }

        this.setState( prev => ({ ...prev, [key]: value, invalidEmailMsg: null}) );
    }

    submit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const { email } = this.state;

        if (!email || !Validate.isEmail(email)) {
            this.setState({
                invalidEmailMsg: lang.template('邮箱格式不正确，请重新填写')
            });
            return;
        }

        cache.setCache(this.cacheKey, {
            email
        });

        this.props.handleConfirm({
            email
        });
    }

    toggleCheckbox() {
        this.setState({
            agreed: !this.state.agreed
        });
    }

    render() {
        return (
            <div className="popup-wrapper confirm-form">
                <div className="box-hd">
                    <div className="title">
                        { lang.template('支付所需资料') }
                    </div>
                </div>
                <div className="content">
                    <p className="title-desc">{ lang.template('为确保您能收到发票等信息，请在此处填写邮箱。') }</p>
                <form onSubmit={ e => this.submit(e) } noValidate="noValidate">
                <div className="input-wrapper email">
                            <i/>
                            <input onChange={ e => this.onInputChange( e, 'email') }
                                   value={ this.state.email }
                                   placeholder={ lang.template('请输入邮箱') }
                                   type="email"/>
                            {
                                this.state.invalidEmailMsg ?
                                    (<p className="error-tip">{ this.state.invalidEmailMsg }</p>) : null
                            }
                        </div>
                        <div className="btns">
                            <button className="enabled">{ lang.template('确认') }</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/orderview/channels/paystack/confirm-form.js